import { ValidatorFn, AbstractControl } from "@angular/forms";

export const VALID_POSTCODE_REGEXP_BE = /^(?:(?:[1-9])(?:\d{3}))$/;
export const VALID_POSTCODE_REGEXP_NL = /^[1-9][0-9]{3}[A-Z]{2}$/i;

/**
 * Heads up... doesn't work yet. just use the regexp ^^
 * @param postcodeRe
 */
export function postcodeValidator(
    postcodeRe: RegExp = VALID_POSTCODE_REGEXP_BE
): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const validPostcode = postcodeRe.test(value);
        console.log({ value, validPostcode });
        return validPostcode
            ? { validPostcode: { value: control.value } }
            : null;
    };
}
